import React from 'react';
import styled from 'styled-components';
import Image from '../../parts/Image';
import Text from '../../parts/Text';
import { GetAdministratorsUsers200ResponseInner } from '../../../../api/v1';
import NoUserImage from '../../../assets/images/no_user_image.webp';

type UserListComponentProps = {
  users: Array<GetAdministratorsUsers200ResponseInner>
}

const UserCardsStyle = styled.div`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 12px;
  }

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out
  }
`;

const UserCardColumnLeft = styled.div`
  margin-right: 20px;
`;

const UserCardColumnRight = styled.div`
  margin-right: 20px;
`;

const AdministratorUserList: React.FC<UserListComponentProps> = ({ users }) => {
  return (
    <>
      { users.map((user, index) => {
        return (
          <UserCardsStyle key={index}>
            <UserCardColumnLeft>
              <Image src={user.image?.url || NoUserImage} width='50px' height='50px' />
            </UserCardColumnLeft>
            <UserCardColumnRight>
              <Text size='14px' weight="bold" mb='5px'>{user.email}</Text>
              <Text size='14px' mb='5px'>{user.id}</Text>
              <Text size='14px' mb='5px'>{user.username}</Text>
              <Text size='14px' mb='5px'>{user.name}</Text>
              <Text size='14px' mb='5px'>{user.birthday}</Text>
            </UserCardColumnRight>
          </UserCardsStyle>
        );
      })}
    </>
  );
};

export default AdministratorUserList;
